import React, { useState } from "react";
import {  useSelector } from "react-redux";
//antd
import {
  Button,
  Modal,
  Form,
  Input,
  DatePicker,
  Select,
  Row,
  Col,
  Radio,
} from "antd";
//utils
import * as consts from "../../../utils";
import * as rules from "../../../utils";
import { Ast, Label, disabledDate, titleCase } from "../../../utils";

// import {
//   addExpLaboral,
//   updateExpLaboral,
//   loadRecordExpLaboral,
// } from "../../../redux/aspirante/aspiranteDucks";

const { TextArea } = Input;

//Props de inputs
const props = {
  autoComplete: "off",
};

const propsSelect = {
  showSearch: true,
  allowClear: true,
  optionFilterProp: "children",
  placeholder: "Selecciona una opción",
};

// let id = 0;
/**
 * Componente que muestra el modal de registro para capturar una nueva experiencia laboral
 * @param {boolean} isModalVisible para mostrar el modal
 * @param {function} showModal Para mostrar u ocultar el modal
 * @param {object} form Para manejar el estado del formulario, proviene del useForm
 * @returns JSX.Element Modal de registro
 */
export const ModalForm = ({
  isModalVisible,
  showModal,
  form,
  actFechaFin,
  setActFechaFin,
}) => {
  // const dispatch = useDispatch();

  const [actual, setActual] = useState(null);
  const [requerido, setRequerido] = useState(false);
  const { areasExperiencia, remuneraciones } = useSelector(
    (state) => state.catalogos
  );
  const { recordExpLaboral } = useSelector(
    (state) => state.aspirante.aspirante
  );
  const { id: idModifica } = recordExpLaboral;

  const selectRadio = (e) => {
    setActual(e.target.value);
    setActFechaFin(e.target.value === 1);
    if (e.target.value === 1) {
      form.setFieldsValue({ fhfin: null });
      setRequerido(false);
    } else {
      setRequerido(true);
    }
  };

  /**
   * Función que guarda la experiencia laboral en lista que se muestra en la pantalla
   */
  const saveForm = () => {
    form
      .validateFields()
      .then((values) => {
        // const json = { id: ++id, ...values };
        // dispatch(addExpLaboral(json));
        form.resetFields();
        showModal();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  /**
   * Función que actualiza el registro de experiencia laboral
   */
  const updateForm = () => {
    form
      .validateFields()
      .then((values) => {
        // const json = { id: idModifica, ...values };
        // dispatch(updateExpLaboral(json));
        form.resetFields();
        // dispatch(loadRecordExpLaboral({}));
        showModal();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /**
   * Oculta el modal y limpia el formulario
   */
  const onCancel = () => {
    form.resetFields();
    // dispatch(loadRecordExpLaboral({}));
    showModal();
  };

  return (
    <Modal
      title={idModifica ? "Editar experiencia" : "Agregar nueva experiencia"}
      visible={isModalVisible}
      onOk={saveForm}
      onCancel={onCancel}
      centered
      maskClosable={false}
      destroyOnClose={true}
      footer={[
        <center key="guardar">
          {idModifica ? (
            <Button type="primary" onClick={updateForm}>
              Modificar
            </Button>
          ) : (
            <Button type="primary" onClick={saveForm}>
              Guardar
            </Button>
          )}
        </center>,
      ]}
    >
      <>
        <label className="requeridos">
          Los campos con ( <Ast />) son necesarios.
        </label>

        <Form form={form} layout="vertical" style={{ marginTop: 20 }}>
          {/* CARGO EXPERIENCIA */}
          <Form.Item
            label={<Label label={"Cargo"} isRequired />}
            name="cargo"
            rules={rules.TXT_ALFANUMERICO_REQ_PAR100}
          >
            <Input
              maxLength={100}
              {...props}
              onInput={(e) => (e.target.value = titleCase(e.target.value))}
            />
          </Form.Item>

          {/* AREA EXPERIENCIA */}
          <Form.Item
            label={
              <Label label={"Área profesional o de experiencia"} isRequired />
            }
            name="area"
            rules={rules.REQUERIDO}
          >
            <Select
              {...propsSelect}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {areasExperiencia !== undefined &&
                areasExperiencia.map(({ areaId, nombre }) => (
                  <Select.Option key={areaId}>{nombre}</Select.Option>
                ))}
            </Select>
          </Form.Item>

          {/* EMPRESA EXPERIENCIA */}
          <Form.Item
            label={<Label label={"Nombre de la empresa"} isRequired />}
            name="empresa"
            rules={rules.TXT_ALFANUMERICO_REQ_PAR200}
          >
            <Input
              maxLength={200}
              {...props}
              onInput={(e) => (e.target.value = titleCase(e.target.value))}
            />
          </Form.Item>

          {/* REMUNERACION EXPERIENCIA */}
          <Form.Item
            label={<Label label={"Remuneración"} isRequired />}
            name="remuneracion"
            rules={rules.REQUERIDO}
          >
            <Select
              {...propsSelect}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {remuneraciones !== undefined &&
                remuneraciones.map(({ remuneracionId, remuneracion }) => (
                  <Select.Option key={remuneracionId}>
                    {remuneracion}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          {/* FUNCIONES EXPERIENCIA */}
          <Form.Item
            label={<Label label={"Funciones"} />}
            name="funciones"
            rules={rules.TXT_ALFANUMERICO_V2}
          >
            <TextArea
              autoSize={{ minRows: 3, maxRows: 5 }}
              showCount
              maxLength={2000}
            />
          </Form.Item>
          {/* ACTUAL EXPERIENCIA */}

          <label>
            <Ast /> Sigo trabajando aquí
          </label>
          <Row gutter={24}>
            <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item
                className="collection-create-form_last-form-item"
                name="actual"
              >
                <Radio.Group value={actual} onChange={selectRadio}>
                  <Radio value={1}>Sí</Radio>
                  <Radio value={0}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              {/* FECHA INICIAL EXPERIENCIA */}
              <Form.Item
                label={<Label label={"Desde"} />}
                name="fhini"
                rules={rules.FECHAS_REQ}
              >
                <DatePicker
                  format={consts.DATE_FORMAT}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>
            <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              {/* FECHA FINAL EXPERIENCIA */}
              <Form.Item
                label={<Label label={"Hasta"} />}
                name="fhfin"
                rules={requerido ? rules.FECHAS_REQ : rules.FECHAS}
              >
                <DatePicker
                  format={consts.DATE_FORMAT}
                  disabledDate={disabledDate}
                  disabled={actFechaFin}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </>
    </Modal>
  );
};
